import React from 'react'
import Sections from './Sections'
import Terms from './Terms'

const MyFooter = () => {
  return (
    <div className='bg-white'>
      {/* <Sections/> */}
      <Terms/>
    </div>
  )
}

export default MyFooter